module.exports = __webpack_public_path__ + "static/media/ball-app.1bf41b0b.svg";